module.exports = __webpack_public_path__ + "img/img-shipin-s5-tuya.c6063fac.png";